"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderedReplacementsByZone = exports.allowedZones = exports.replacementsByZone = void 0;
var exceptions_1 = require("./exceptions");
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
exports.replacementsByZone = {
    '.wildberries.ru': {
        'basket-stage-v2.wb.ru': 'basket-stage-v2.wb.ru',
        '.wb.ru': '.wildberries.ru',
    },
    '.wb.ru': __assign(__assign({}, exceptions_1.exceptionsMap), { 'seller.wildberries.ru': 'seller-portal-stage.wb.ru', 'wildberries.ru': 'wb.ru', 'openapi.wildberries.ru': 'openapi.wildberries.ru' }),
    '.wildberries.cn': __assign(__assign({}, exceptions_1.exceptionsMap), { 'www.wildberries.ru': 'www.wildberries.ru', 'wildberries.ru': 'wildberries.ru', '.wildberries.ru': '.wildberries.cn', '.wbbasket.ru': '.wbcontent.net', '\\.wbbasket\\.ru': '\\.wbcontent\\.net', 'basket-stage-v2.wb.ru': 'ali-basket-stage-v2.wildberries.cn', 'static-basket-02.wbbasket.ru': 'ali-static-basket-02.wildberries.cn' }),
    '.wb.cn': __assign(__assign({}, exceptions_1.exceptionsMap), { 'www.wildberries.ru': 'www.wildberries.ru', 'wildberries.ru': 'wildberries.ru', 'seller.wildberries.ru': 'seller-portal-stage.wb.cn', '.wildberries.ru': '.wb.cn', '.wb.ru': '.wb.cn', 'basket-stage-v2.wb.ru': 'ali-basket-stage-v2.wildberries.cn', 'static-basket-02.wbbasket.ru': 'ali-static-basket-02.wildberries.cn', '.wbbasket.ru': '.wbcontent.net', '\\.wbbasket\\.ru': '\\.wbcontent\\.net', 'openapi.wildberries.ru': 'openapi.wildberries.cn' }),
    '.wildberries.by': __assign(__assign({}, exceptions_1.exceptionsMap), { 'wildberries.ru': 'wildberries.by' }),
    '.wb.by': __assign(__assign({}, exceptions_1.exceptionsMap), { 'seller.wildberries.ru': 'seller-portal-stage.wb.by', 'www.wildberries.ru': 'www.wildberries.by', 'wildberries.ru': 'wildberries.by', '.wildberries.ru': '.wb.by', '.wb.ru': '.wb.by', 'openapi.wildberries.ru': 'openapi.wildberries.by' }),
};
exports.allowedZones = Object.keys(exports.replacementsByZone);
exports.orderedReplacementsByZone = exports.allowedZones.reduce(function (acc, key) {
    var replacements = exports.replacementsByZone[key];
    if (!replacements) {
        return acc;
    }
    acc[key] = Object.keys(replacements)
        .sort(
    // eslint-disable-next-line id-length
    function (a, b) { return b.length - a.length; })
        .map(escapeRegExp);
    return acc;
}, {});
